import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SongTable from '../components/SongTable';
import axios from 'axios';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Scroll to top when search query changes
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const fetchSearchResults = async () => {
      if (!query) return;

      setLoading(true);
      try {
        const { data } = await axios.get(`/api/search?q=${encodeURIComponent(query)}`);
        const flattenedSongs = data.songs.map(entry => ({ ...entry.song, ...entry }));
        setSongs(flattenedSongs);
      } catch (err) {
        console.error('❌ Failed to fetch search results:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [query]);

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">
        🔍 Search results for “{query}”
      </h1>

      {loading ? (
        <p>⏳ Searching...</p>
      ) : songs.length === 0 ? (
        <p>No results found.</p>
      ) : (
        <SongTable
          songs={songs}
          showTime={false}
          showRequest
          disableRequestIf={() => false}
          hideRequester={true}
        />
      )}
    </div>
  );
}
